// Tipos que devuelve saaservices GET /abaco/cierretj (AbacoDAO.getCierreTj):
// 1 = M9 válidos, 2 = M5 válidos, 3 = M9 premios pagados, 4 = M5 premios pagados.
// El filtro de pantalla agrupa por tipo de cierre: cada cierre incluye sus premios pagados.
export const CIERRE_FILTER = {
  ALL: "",
  M9: "M9",
  M5: "M5",
};

const TIPOS_POR_CIERRE = {
  [CIERRE_FILTER.M9]: [1, 3],
  [CIERRE_FILTER.M5]: [2, 4],
};

const LABEL_KEY_POR_TIPO = {
  1: "closureTypeM9",
  3: "closureTypeM9",
  2: "closureTypeM5",
  4: "closureTypeM5",
};

export const CIERRE_FILTER_OPTIONS = [
  { value: CIERRE_FILTER.ALL, labelKey: "closureTypeAll" },
  { value: CIERRE_FILTER.M9, labelKey: "closureTypeM9" },
  { value: CIERRE_FILTER.M5, labelKey: "closureTypeM5" },
];

export const filterByCierre = (rows, cierre) => {
  const tipos = TIPOS_POR_CIERRE[cierre];
  if (!tipos) return rows;
  return rows.filter((row) => tipos.includes(Number(row.tipo)));
};

export const getCierreLabelKey = (tipo) => LABEL_KEY_POR_TIPO[Number(tipo)];

// f_cietj llega como "DD/MM/YYYY HH24:MI"; se convierte a "YYYYMMDDHHMI" para comparar
const fechaCierreKey = (fecha) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/.exec(fecha ?? "");
  if (!match) return "";
  const [, dd, mm, yyyy, hh, mi] = match;
  return `${yyyy}${mm}${dd}${hh}${mi}`;
};

const compareNumber = (field) => (a, b) =>
  (Number(a[field]) || 0) - (Number(b[field]) || 0);

const compareAgencia = compareNumber("c_agent");
const compareSubagencia = compareNumber("c_subag");
const compareTerminal = compareNumber("c_maqui");

const compareFechaCierre = (a, b) =>
  fechaCierreKey(a.f_cietj).localeCompare(fechaCierreKey(b.f_cietj));

// Orden ascendente por agencia, subagencia, terminal y fecha de cierre. El número
// de terminal se repite entre subagencias, por eso la subagencia va antes. El
// sort es estable: ante empate se conserva el orden del backend (juego, válidos
// antes que premios).
export const sortCierres = (rows) =>
  [...rows].sort(
    (a, b) =>
      compareAgencia(a, b) ||
      compareSubagencia(a, b) ||
      compareTerminal(a, b) ||
      compareFechaCierre(a, b),
  );
